module.exports = __webpack_public_path__ + "img/sec4_1.ad487be1.png";